'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _App = require('./containers/App');

var _App2 = _interopRequireDefault(_App);

var _TopPage = require('./containers/TopPage');

var _TopPage2 = _interopRequireDefault(_TopPage);

var _CountryPage = require('./containers/CountryPage');

var _CountryPage2 = _interopRequireDefault(_CountryPage);

var _HotelSearchPage = require('./containers/HotelSearchPage');

var _HotelSearchPage2 = _interopRequireDefault(_HotelSearchPage);

var _HotelInformationPage = require('./containers/HotelInformationPage');

var _HotelInformationPage2 = _interopRequireDefault(_HotelInformationPage);

var _NotFoundPage = require('./containers/NotFoundPage');

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _page = require('./modules/page');

var _search = require('./modules/search');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// action creators


// containers
function routes(store) {
  /**
   * Please keep routes in alphabetical order
   */

  /**
   * A curry function to generate a Route onEnter callback to get the Document Head of each different Route.
   * @param  {[Object]}   page The page name to query the required Document Head
   * @return {[Function]}      A Route onEnter callback
   */
  var loadDocumentHead = function loadDocumentHead(page) {
    return function (nextState, replace, cb) {
      store.dispatch((0, _page.load)(store.getState().i18n, page));
      cb();
    };
  };

  function getCurrency() {
    // always update the search.currency state from the cookie because a user may change it in other windows
    if (_reactCookie2.default.load('currency')) {
      store.dispatch((0, _search.update)({ currency: _reactCookie2.default.load('currency') }));
    }
  }

  function onRouteChange() {
    getCurrency();
  }

  return _react2.default.createElement(
    _reactRouter.Route,
    { path: _config2.default.urls.app.root, onChange: onRouteChange, component: _App2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _TopPage2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: _config2.default.urls.app.spot, component: _HotelSearchPage2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: _config2.default.urls.app.city, component: _HotelSearchPage2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: _config2.default.urls.app.subdivision, component: _HotelSearchPage2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: _config2.default.urls.app.country, component: _CountryPage2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: _config2.default.urls.app.hotel, component: _HotelInformationPage2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: _config2.default.urls.app.simpleHotel, component: _HotelInformationPage2.default }),
    _react2.default.createElement(_reactRouter.Redirect, { from: _config2.default.urls.app.oldSpot, to: _config2.default.urls.app.spot }),
    _react2.default.createElement(_reactRouter.Redirect, { from: _config2.default.urls.app.oldHotellist, to: _config2.default.urls.app.hotellist }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _NotFoundPage2.default, status: 404, onEnter: loadDocumentHead('notfound') })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 1249
// module chunks = 0